/**
 * Copyright © 2025 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const UPDATE_NOTIFICATION_SUBSCRIPTION = gql`
  mutation UpdateNotificationSubscription(
    $data: UpdateNotificationSubscriptionInput!
  ) {
    updateNotificationSubscription(data: $data) {
      id
      channels
      rule {
        id
        name
        targetId
        targetType
        triggerCondition
      }
    }
  }
`
